export default __webpack_public_path__ + "static/media/transaction.4c107969.svg";